import {Session as module} from '../actions/index';
const {actiontypes} = module;


const initialState = {
  user: null,
  token: localStorage.getItem('token') || null,
}

export default function session(state = initialState, action) {
  switch(action.type) {
    case actiontypes.LOGIN_SUCCESS:
      return {...state,
        token: action.token,
        user: {...action.user}
      };
    default:
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/session.js